import { render } from "./NotifyPage.vue?vue&type=template&id=4b122a4d"
import script from "./NotifyPage.vue?vue&type=script&lang=js"
export * from "./NotifyPage.vue?vue&type=script&lang=js"

import "./NotifyPage.vue?vue&type=style&index=0&id=4b122a4d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__